<template>
	<page-content-layout class="movings" title="Movings">
		<input class="tool-text" placeholder="Søg" type="text" slot="tools" v-model="src" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Regnsk.',
				value: 'accounting'
			},
			{
				label: 'Timer',
				value: 'hours'
			}
		]" v-model="view" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Køret.',
				value: 'vehicle'
			},
			{
				label: 'Opg.',
				value: 'task'
			},
			{
				label: 'Navn',
				value: 'name'
			}
		]" v-model="sort" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Alle',
				value: 'all'
			},
			{
				label: 'Afv.',
				value: 'pending'
			},
			{
				label: 'Godk.',
				value: 'approved'
			}
		]" v-model="filter" />
		<button-view slot="tools" @click="exportButtonClick" label=">" />
		<div class="layout">
			<date-picker-std-view v-model="date" class="date" @browse="updateStatus" />
			<div class="tasks"></div>
			<hour-view class="list" :mode="view" :date="date" :employees="employees" :vehicles="vehicles" :events="events" :tasks="_tasks" :bookings="bookings" @enterEmployee="enterEmployee" @leaveEmployee="leaveEmployee" @approve="approve" @context="contextEmp" :filter="filter" :search="src" :sort="sort" @update="update" />
		</div>
		<hour-hover-view :date="date" :item="emp" align="right" />
		<vehicle-hover-view v-if="$store.state.hoverType == 'vehicle'" :item="$store.state.hover" :align="$store.state.hoverAlign" :roles="vehicleRoles" :events="events" />
	</page-content-layout>
</template>

<script>
	import merge from '../functions/merge'

	import NewTableView from '../views/NewTableView'

	import ContextPopupView from '../views/ContextPopupView'

	import DatePickerStdView from '../views/DatePickerStdView'

	import LeadModel from '../model/Reservation'

	import ReservationWindow from '../windows/HoursWindow2'
	import SalaryExportWindow from '../windows/SalaryExportWindow'

	import HourView from '../views/HourView'

	import HourHoverView from '../views/HourHoverView'

	import HoverView from '../views/HoverView'
	import VehicleHoverView from '../views/VehicleHoverView'

	import { bus } from '../../bus'

    export default {
		data() {
			return {
				src: '',

				view: 'accounting',
				sort: 'vehicle',

				emp: null,
				employees: [],
				vehicles: [],

				tasks: [],
				bookings: [],
				events: [],

				items: [],
				colors: [],
				status: [],
				calStatus: [],
				//types: [],
				date: (new Date()).format('Y-m-d'),
				checked: [],



				types: [],
				departments: [],
				emps: [],
				instructions: [],
				vehicleRoles: [],
				vehicleEvents: [],


				abortUpdate: null,


				filter: 'all'
			};
		},
		watch: {
			date(n, o) {
				this.update();
			}
		},
		components: {
			'NewTableView': NewTableView,
			'DatePickerStdView': DatePickerStdView,
			'HourView': HourView,
			'HourHoverView': HourHoverView,
			hoverView: HoverView,
			vehicleHoverView: VehicleHoverView
		},
		computed: {
			_calStatus() {
				var r = [];

				for (var date in this.calStatus) {
					var s = this.calStatus[date];

					r.push({
						date: date,
						color: s.pending > 0 ? 'yellow' : 'gray',
						label: s.pending + (s.pending > 1 ? ' opgaver mangler planlægning' : ' opgave mangler planlægning')
					});
				}

				return r;
			},
			_status() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].value] = this.status[i].label;
				}

				return r;
			},
			_types() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				

				return r;
			},
			_tasks() {
				return this.tasks;
			},
			_departments() {
				var r = {};

				for (var i = 0; i < this.departments.length; ++i) {
					r[this.departments[i].id] = this.departments[i];
				}

				

				return r;
			},
			_instructions() {
				var r = {};

				for (var i = 0; i < this.instructions.length; ++i) {
					r[this.instructions[i].name] = this.instructions[i];
				}

				

				return r;
			},
			_employees() {
				var r = {};

				for (var i = 0; i < this.emps.length; ++i) {
					r[this.emps[i].id] = this.emps[i];
				}

				

				return r;
			},		
		},
		methods: {
			exportButtonClick() {
				

				var self = this;

				this.$store.state.windowStack.push(SalaryExportWindow, { 
					submit: async function (entity, type) {
						
						this.$store.state.windowStack.pop();

						if (type == 'hours') window.open(process.env.VUE_APP_API + 'employees/salary/csv/?token=' + self.$store.state.auth + '&from=' + entity.from + '&to=' + entity.to);
						if (type == 'extra') window.open(process.env.VUE_APP_API + 'employees/extra/csv/?token=' + self.$store.state.auth + '&from=' + entity.from + '&to=' + entity.to);
						if (type == 'all') window.open(process.env.VUE_APP_API + 'employees/all/csv/?token=' + self.$store.state.auth + '&from=' + entity.from + '&to=' + entity.to);
					}
				});
			},
			search(comments) {
				var words = ['byrde', 'tungløft', 'faktura'];
				var r = [];
				var c = comments.toLowerCase();

				for (var i = 0; i < words.length; ++i) {
					if (c.indexOf(words[i]) > -1) {
						r.push(words[i]);
					}
				}

				return r;
			},
			approve(emp) {
				

				var self = this;

				this.$store.state.windowStack.push(ReservationWindow, {
					entity: {
						hours: emp.approved ? emp.approved : emp.hours,
						extra: emp.extra ? emp.extra : '',
						remarks: emp.remarks ? emp.remarks : '',
						name: emp.name,
						search: this.search(emp.allTasks.reduce((acc, item) => { return acc + item.comments; }, ''))
					}, 
					submit: async function (entity) {
						this.$store.state.windowStack.pop();
						await self.axios.put('/employees/' + emp.id + '/hours/' + self.date + '/', entity);
						self.update();
					}, 
					reset: async function (entity) {
						this.$store.state.windowStack.pop();
						await self.axios.delete('/employees/' + emp.id + '/hours/' + self.date + '/');
						self.update();
					}
				});
			},

			async contextEmp(emp) {
				//this.emp = emp;
				

				if (!confirm('Sikker?')) return;

				await this.axios.put('/employees/' + emp.id + '/hours/' + this.date + '/transfered/');
				this.update();
			},

			enterEmployee(emp) {
				this.emp = emp;
				
			},

			leaveEmployee(emp) {
				this.emp = null;
				
			},

			async itemClick(item) {
				this.open(item.id);
			},
			itemContext(item, event) {
				event.stopPropagation();

				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: [
						{
							label: 'Opret kopi',
							action: async function () {
								alert('Ikke klar');
							}
						},
						null,
						{
							label: 'Slet',
							action: async function () {
								if (await LeadModel.delete(self.axios, item.id)) {
									self.update();
								}
							}
						}
					]
				});
			},
			async open(id) {
				var self = this;	

				

				this.$store.state.windowStack.push(ReservationWindow, {
					entity: id ? await LeadModel.read(self.axios, id) : LeadModel.entity(), 
					submit: async function (entity) {
						if (await LeadModel.save(self.axios, entity)) {
							self.$store.state.windowStack.pop();
							self.update();
						}
					}
				});
			},
			updateStatus(year, month) {
				var self = this;

				this.calStatus = [];

				this.axios
					.get('/planning/reservations/state/' + year + '/' + month + '/')
					.then(function (r) {
						self.calStatus = r.data;
					});

				
			},
			async update() {
				this.axios.put('/activity/hours/');

				if (this.abortUpdate) {
					this.abortUpdate.abort();
					this.abortUpdate = null;
				}

				this.abortUpdate = new AbortController();

				this.items = null;

				this.employees		= [];
				this.tasks			= [];
				this.bookings		= [];
				this.events			= [];

				const d = new Date(this.date);

				const [hours, tasks, bookings, events] = await Promise.all([
					this.axios.get(`/employees/hours/?date=${this.date}`, { signal: this.abortUpdate.signal }),
					this.axios.get(`/planning/tasks/${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}/`, { signal: this.abortUpdate.signal }),
					this.axios.get(`/planning/bookings/${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}/`, { signal: this.abortUpdate.signal }),
					this.axios.get(`/fleet/vehicles/events/?date=${this.date}`, { signal: this.abortUpdate.signal }),
				]);

				this.employees		= hours.data;
				this.tasks			= tasks.data;
				this.bookings		= bookings.data._items;
				this.events			= events.data;
			},
			async updateCore() {
				const [departments, vehicles, types, emps, instructions, vehicleRoles] = await Promise.all([
					this.axios.get(`/us/departments/`),
					this.axios.get(`/fleet/vehicles/`),
					this.axios.get(`/tasks/types/`),
					this.axios.get(`/employees/`),
					this.axios.get(`/tasks/instructions/`),
					this.axios.get(`/fleet/vehicles/roles/`),
				]);

				this.departments	= departments.data._items;
				this.vehicles		= vehicles.data._items;
				this.types			= types.data._items;
				this.emps			= emps.data._items;
				this.instructions	= instructions.data._items;
				this.vehicleRoles	= vehicleRoles.data._items;
			}
		},
		mounted() {
			const self = this;

			this.update();
			this.updateCore();

			bus.$on('update', function () {
				self.update();
				self.updateCore();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 40px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		grid-column: 2 / 3;
		grid-row: 1 / 3;
		border-left: 1px solid #cecece;
	}
</style>